module.exports = __webpack_public_path__ + "img/dropdown-toggle-20x20.1bfb02ed.svg";